export default __webpack_public_path__ + "static/media/village-marketing-showcase.abc7da92.mp4";